import type React from 'react';

import type { ErrorHandlerProps } from '#src/app/pages/newsAndGuides/details/pageContext';

export const NewsAndGuidesDetailsErrorHandler: React.FC<ErrorHandlerProps> = ({ context: { error } }) => {
	throw new Error(`Failed to retrieve data for NewsAndGuidesDetails page (error: ${error})`);
};
